import React, { useState } from 'react';

function FolderOutline({ style, onMouseEnter, onMouseLeave }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            width="30"
            height="20"
            fill="#FDBE34"
            style={style}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <path d="M2 16c0-2.21 1.79-4 4-4h18l4 4h34c1.1 0 2 .9 2 2v30c0 2.21-1.79 4-4 4H6c-2.21 0-4-1.79-4-4V16z" />
            <path
                d="M2 16v-2c0-2.21 1.79-4 0-4h20l4 4h30c1.1 0 2 .9 2 2v2H2z"
                fill="#F7C948"
            />
        </svg>
    );
}

export default function FolderOutlineIcon() {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FolderOutline
            style={{
               marginRight: "10px",
               marginLeft: "-10px",
                color: !isHovered ? "rgb(163, 149, 218)" : "#1890ff",
                cursor: "pointer",
                transition: "transform 0.3s ease, color 0.3s ease",
                transform: isHovered ? "scale(1.2)" : "scale(1)",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        />
    );
}
